import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2'
import axios from 'axios'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Modal from '@material-ui/core/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import { useLocation, useHistory } from "react-router-dom";
import onSubmitWorking from './SubmitWorking'
import Header from '../Element/Header'


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    paperModal: {
        position: 'absolute',
        width: 500,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    input: {
        marginTop: '3%'
    },
    root: {
        marginTop: '2%'
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    typography: {
        marginTop: '5%'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    containerTextHeader: {
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex'
    },
    endYear: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));

async function updateBiodata(expecSalary, nationality, softSkills, hardSkills, hobbiesInterest, orgExp, educationNonFormal, currentRole, noticePeriod, participantId, history, location) {
    let array = [expecSalary, nationality, softSkills, hardSkills, hobbiesInterest, orgExp, educationNonFormal, currentRole, noticePeriod]

    for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element == null || element == '') {
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Lengkapi data mu`,
            })
        }
    }

    //disini buat endpoint biodata
    if (location.state.exist === true) {
        console.log('masuk')
        console.log('location.state', location.state)
        let marital_status = {
            'Kawin': 1,
            'Cerai': 2,
            'Belum Kawin': 3
        }

        let religion = {
            'Islam': 1,
            'Katolik': 2,
            'Protestan': 3,
            'Hindu': 4,
            'Budha': 5,
            'Kristen': 6
        }
        let getStorageBiodata = JSON.parse(localStorage.getItem("biodata"))
        let getStorageEducation = JSON.parse(localStorage.getItem("education"))

        let gender_short = ''
        if (getStorageBiodata.gender === 'Laki - Laki') {
            gender_short = 'L'
        } else if (getStorageBiodata.gender === 'Perempuan') {
            gender_short = 'P'
        } else {
            gender_short = ''
        }

        const result = await axios({
            method: 'post',
            data: {
                nik: getStorageBiodata.nik,
                gender: gender_short,
                birth_place: getStorageBiodata.birthPlace,
                birth_date: getStorageBiodata.selectedDateBorn,
                marital_id: marital_status[getStorageBiodata.marital],
                religion_id: religion[getStorageBiodata.religion],
                address: getStorageBiodata.address,
                kelurahan: getStorageBiodata.kelurahan,
                kecamatan: getStorageBiodata.kecamatan,
                kabupaten: getStorageBiodata.districts.code,
                provinsi: getStorageBiodata.province.iso,
                kodepos: getStorageBiodata.postalCode,
                competency: getStorageEducation.competency,
                edu_institution: getStorageEducation.edu_institution,
                edu_degree: getStorageEducation.edu_degree,
                edu_major: getStorageEducation.edu_major,
                edu_grad_year: getStorageEducation.edu_grad_year,
                edu_grade: getStorageEducation.edu_grade,
                photo: getStorageEducation.upload,
                expec_salary: expecSalary,
                nationality: nationality,
                soft_skills: softSkills,
                hard_skills: hardSkills,
                hobbies_interest: hobbiesInterest,
                org_exp: orgExp,
                education_non_formal: educationNonFormal,
                current_position: currentRole,
                notice_period: noticePeriod,
                participant_id: participantId,
                payment_id: location.state.payment_id,
                is_main_user: location.state.is_main_user
            },
            url: `${process.env.REACT_APP_API}/participant/biodata/update/participant`,
        })

        if (result.data.package_active === true) {
            window.localStorage.clear();
            return history.push({
                pathname: '/participant/register/biodata',
                state: {
                    countParticipant: parseInt(location.state.countParticipant) + parseInt(result.data.countPackageUser),
                    name: '',
                    email: '',
                    no_wa: '',
                    zoom_user: '',
                    is_main_user: false,
                    payment_id: location.state.payment_id,
                    getParticipant: "",
                    getPayment: location.state.getPayment
                }
            })
        } else if (result.data.package_active === false) {
            window.localStorage.clear();
            return history.push({
                pathname: '/biodata/success',
                state: { name: location.state.name, getPayment: location.state.payment_id }
            })
        }
    }

    const result = await axios({
        method: 'post',
        data: {
            expec_salary: expecSalary,
            nationality: nationality,
            soft_skills: softSkills,
            hard_skills: hardSkills,
            hobbies_interest: hobbiesInterest,
            education_non_formal: educationNonFormal,
            current_role: currentRole,
            notice_period: noticePeriod,
            org_exp: orgExp,
            participant_id: participantId,
            payment_id: location.state.payment_id
        },
        url: `${process.env.REACT_APP_API}/company/update`,
    })

    if (result.data.package_active === true) {
        window.localStorage.clear();
        history.push({
            pathname: '/participant/register/biodata',
            state: {
                countParticipant: parseInt(location.state.countParticipant) + parseInt(result.data.countPackageUser),
                name: '',
                email: '',
                no_wa: '',
                zoom_user: '',
                is_main_user: false,
                payment_id: location.state.payment_id,
                getParticipant: "",
                getPayment: ""
            }
        })
    } else if (result.data.package_active === false) {
        window.localStorage.clear();
        history.push({
            pathname: '/biodata/success',
            state: { name: location.state.name, getPayment: location.state.payment_id }
        })
    } else {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `failed update`,
        })
    }
}

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

export default function WorkingRegister() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [participantId, setParticipantId] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [position, setPosition] = useState('')
    const [lokasi, setLokasi] = useState('')
    const [salary, setSalary] = useState('')
    const [startYear, setStartYear] = useState('')
    const [endYear, setEndYear] = useState('')
    const [summary, setSummary] = useState('')
    const [working, setWorking] = useState([])
    const [expecSalary, setExpecSalary] = useState(null)
    const [nationality, setNationality] = useState(null)
    const [softSkills, setSoftSkills] = useState(null)
    const [hardSkills, setHardSkills] = useState(null)
    const [hobbiesInterest, setHobbiesInterest] = useState(null)
    const [orgExp, setOrgExp] = useState(null)
    const [educationNonFormal, setEducationNonFormal] = useState(null)
    const [currentRole, setCurrentRole] = useState(null)
    const [noticePeriod, setNoticePeriod] = useState(null)


    const handleChangeExpecSalary = (event) => {
        setExpecSalary(event.target.value);
    }

    const handleChangeNationality = (event) => {
        setNationality(event.target.value)
    }

    const handleChangeSoftSkills = (event) => {
        setSoftSkills(event.target.value)
    }

    const handleChangeHardSkills = (event) => {
        setHardSkills(event.target.value)
    }

    const handleChangeHobbiesInterest = (event) => {
        setHobbiesInterest(event.target.value)
    }

    const handleChangeorgExp = (event) => {
        setOrgExp(event.target.value)
    }

    const handleChangeEducationNonFormal = (event) => {
        setEducationNonFormal(event.target.value)
    }

    const handleChangeCurrentRole = (event) => {
        setCurrentRole(event.target.value)
    }

    const handleChangeNoticePeriod = (event) => {
        setNoticePeriod(event.target.value)
    }

    const handleOpen = () => {
        setCompanyName('')
        setPosition('')
        setLokasi('')
        setSalary('')
        setStartYear('')
        setEndYear('')
        setSummary('')
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        setEndYear(null)
        setChecked(event.target.checked);
    };

    useEffect(async () => {
        let participantId = location.state.participantId
        setParticipantId(participantId)
        if (location.state.exist == true) {
            setExpecSalary(location.state.getParticipant.participant_biodatum.expec_salary)
            setNationality(location.state.getParticipant.participant_biodatum.nationality)
            setSoftSkills(location.state.getParticipant.participant_biodatum.soft_skills)
            setHardSkills(location.state.getParticipant.participant_biodatum.hard_skills)
            setHobbiesInterest(location.state.getParticipant.participant_biodatum.hobbies_interest)
            setOrgExp(location.state.getParticipant.participant_biodatum.org_exp)
            setEducationNonFormal(location.state.getParticipant.participant_biodatum.education_non_formal)
            setCurrentRole(location.state.getParticipant.participant_biodatum.current_position)
            setNoticePeriod(location.state.getParticipant.participant_biodatum.notice_period)
        }
    }, [participantId])

    const body = (
        <div style={modalStyle} className={classes.paperModal}>
            <Typography variant="subtitle1">
                ADD WORKING EXPERIENCE
            </Typography>
            <TextField
                variant="outlined"
                required
                fullWidth
                id="company_name"
                label="Company Name"
                name="company_name"
                autoComplete="company_name"
                className={classes.input}
                onChange={e => setCompanyName(e.target.value)}
                value={companyName}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="position"
                label="Position"
                name="position"
                autoComplete="position"
                className={classes.input}
                onChange={e => setPosition(e.target.value)}
                value={position}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="location"
                label="Location"
                name="location"
                autoComplete="location"
                className={classes.input}
                onChange={e => setLokasi(e.target.value)}
                value={lokasi}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="salary"
                label="Salary"
                name="salary"
                autoComplete="salary"
                className={classes.input}
                onChange={e => setSalary(e.target.value)}
                value={salary}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="start_year"
                label="Start Year"
                name="start_year"
                autoComplete="start_year"
                className={classes.input}
                onChange={e => setStartYear(e.target.value)}
                value={startYear}
                size="small"
            />
            <div className={classes.endYear}>
                <TextField
                    variant="outlined"
                    required
                    id="end_year"
                    label="End Year"
                    name="end_year"
                    autoComplete="end_year"
                    className={classes.input}
                    style={{ width: '50%' }}
                    onChange={e => setEndYear(e.target.value)}
                    value={endYear}
                    size="small"
                />
                OR
                <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    size="small"
                />
                Present
            </div>

            <TextField
                id="outlined-multiline-static"
                label="Summary"
                multiline
                fullWidth
                rows={4}
                variant="outlined"
                className={classes.input}
                onChange={e => setSummary(e.target.value)}
                value={summary}
                size="small"
            />

            <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => onSubmitWorking(participantId, companyName, position, lokasi, salary, startYear, endYear, summary, open, setOpen, working, setWorking)}
            >
                SAVE
            </Button>
        </div>
    );

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.header}>
                {/* <Avatar alt="Jababeka Logo" src="/participant/logo512.png" variant="square" className={classes.large} />
                <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6" gutterBottom>
                    VIRTUAL JOB FAIR 2021
                </Typography> */}
                <Header />
                <Typography component="h1" variant="h6" gutterBottom>
                    {location.state.countParticipant ? `Peserta ${location.state.countParticipant}` : null}
                </Typography>
            </div>
            <div className={classes.paper}>
                <Container component="main" maxWidth="md" className={classes.root}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        justifyContent: 'space-around'
                    }}>
                        <TextField size="small" label="Expected Salary" value={expecSalary || ''} onChange={handleChangeExpecSalary} />
                        <TextField size="small" label="Nationality" value={nationality || ''} onChange={handleChangeNationality} />
                        <TextField
                            size="small"
                            id="outlined-basic_1"
                            label="Soft Skills"
                            multiline
                            rows={4}
                            value={softSkills || ''}
                            onChange={handleChangeSoftSkills}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic_2"
                            label="Hard Skills"
                            multiline
                            rows={4}
                            value={hardSkills || ''}
                            onChange={handleChangeHardSkills}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic"
                            label="Hobbies Interest"
                            multiline
                            rows={4}
                            value={hobbiesInterest || ''}
                            onChange={handleChangeHobbiesInterest}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic"
                            label="Organization Experience"
                            multiline
                            rows={4}
                            value={orgExp || ''}
                            onChange={handleChangeorgExp}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic"
                            label="Education Non Formal"
                            multiline
                            rows={4}
                            value={educationNonFormal || ''}
                            onChange={handleChangeEducationNonFormal}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic"
                            label="Current Role"
                            multiline
                            rows={4}
                            value={currentRole || ''}
                            onChange={handleChangeCurrentRole}
                        />
                        <TextField
                            size="small"
                            id="outlined-basic"
                            label="Notice Period"
                            multiline
                            rows={4}
                            value={noticePeriod || ''}
                            onChange={handleChangeNoticePeriod}
                        />
                    </div>
                    <div className={classes.containerTextHeader}>
                        <Typography variant="subtitle1">
                            Working Experience
                    </Typography>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleOpen}
                        >
                            Add
                    </Button>
                    </div>
                    {
                        working.length !== 0 ?
                            working.map((value, index) => {
                                return (
                                    <Card className={classes.root} variant="outlined">
                                        <CardContent>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {value.company_name}
                                            </Typography>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {value.year_start} - {value.year_end === null ? 'Present' : value.year_end}
                                            </Typography>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {value.location}
                                            </Typography>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {value.position}
                                            </Typography>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {value.summary}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                )
                            })
                            : null
                    }
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={() => updateBiodata(expecSalary, nationality, softSkills, hardSkills, hobbiesInterest, orgExp, educationNonFormal, currentRole, noticePeriod, participantId, history, location)}
                    >
                        FINISH
                </Button>
                </Container>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </Container>
    )
}